import React from 'react';
import { m } from 'framer-motion';
import { CreditCardIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { trackMetaEvent } from '../../utils/metaPixel';
import { CHECKOUT_URL } from '../../utils/checkout';
const trustItems = [{
  icon: CreditCardIcon,
  label: 'Pago único'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}];
export function PriceReveal() {
  return <section id="oferta" className="bg-cream-dark py-10 sm:py-14" data-id="element-116" data-mp="10fatbn6t6ljg">
      <div className="mx-auto max-w-xl px-4 text-center sm:px-6" data-id="element-117" data-mp="10glx3n097tak">
        <p className="font-heading text-lg font-semibold text-navy sm:text-xl" data-id="element-118" data-mp="lp3hvrf7y2s9">
          Hoy, el sistema completo cuesta:
        </p>

        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="mt-6 rounded-3xl border border-orange/40 bg-white p-6 shadow-card sm:p-8" data-id="element-119" data-mp="qmn012f1ezph">
          <p className="text-sm text-muted" data-id="element-120" data-mp="u1xcd7qmci3l">
            Valor real: <span className="line-through" data-id="element-121" data-mp="p5zv8z7j77pr">240€</span>
          </p>
          <p className="mt-1 font-heading text-6xl font-extrabold text-orange-hover sm:text-7xl" data-id="element-122" data-mp="12wbr9978lqm6">19€</p>
          <p className="mt-3 text-sm leading-relaxed text-ink sm:text-base" data-id="element-123" data-mp="y5v9xe0apkuj">
            Acceso inmediato a todos los tomos y bonos. De por vida.
          </p>

          <div className="mt-6" data-id="element-124" data-mp="1csoj01j81uea">
            <PrimaryButton fullWidth size="lg" href={CHECKOUT_URL} onClick={() => trackMetaEvent('InitiateCheckout', {
            value: 19,
            currency: 'EUR'
          })} data-id="element-125" data-mp="17vomah89i3zu">
              Acceso Ahora — 19€
            </PrimaryButton>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-muted" data-id="element-126" data-mp="3nmkhsl6zz4kg">
            {trustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-127" data-mp="3jmaejgalas9a">
                <item.icon size={12} data-id="element-128" data-mp="1ml4kt70mkzy0" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}